import type { ProcedureTaskDto, TaskScope } from '@bk/contracts';
import { errorMessage } from '../../lib/api';
import { useTenantQuery } from '../../lib/useTenant';
import { ErrorText } from '../../ui';
import { ProcedureTaskCard } from './ProcedureTaskCard';

/**
 * I compiti dalle procedure attive nella pagina «Oggi» (ADR 0215 tappa 4), con la stessa scelta dei task: i miei, tutti
 * gli aperti o quelli da assegnare (responsabili). Si chiudono qui, con l'esito e il valore misurato per i controlli.
 */
export function MyProcedureTasks({ scope }: { scope: TaskScope }) {
  const s = scope === 'open' || scope === 'unassigned' ? scope : 'mine';
  const q = useTenantQuery<{ data: ProcedureTaskDto[] }>(['procedure-tasks', s], `/procedure-tasks?scope=${s}`, { refetchInterval: 30_000 });
  if (q.error) return <ErrorText>{errorMessage(q.error)}</ErrorText>;
  if (!q.data?.data.length) return null;
  return (
    <section className="mb-5">
      <h2 className="mb-2 text-sm font-medium text-ink/70">
        {s === 'mine' ? 'I miei compiti dalle procedure' : s === 'unassigned' ? 'Compiti dalle procedure da assegnare' : 'Compiti dalle procedure'} ({q.data.data.length})
      </h2>
      <div className="grid gap-2 md:grid-cols-2">
        {q.data.data.map((task) => (
          <ProcedureTaskCard key={task.id} task={task} />
        ))}
      </div>
    </section>
  );
}
